import React from "react";
import "../styles/styles.css";
import LanguageSwitch from "./LanguageSwitch";
import { useI18n } from "../utilities/i18n";

function Header(props) {
  const { t } = useI18n();

  return (
    <div className="headerWrapper">
      <div className="header">
        <div className="headerBrand">
          <img src="/images/afl-logo.png" className="logo" alt="AFL" />
          <span className="headerBrandName">AFL Admin</span>
        </div>
        <div className="headerActions">
          <LanguageSwitch />
          <button type="button" onClick={props.toggleModal} className="loginButton">
            {t('login')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Header;
